import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import ConfirmationModal from '../shared/ConfirmationModal';
import loaderimage from "../../images/giphy.gif";
import NewconfirmationModal from "../shared/NewconfirmationModal";
import AllFailureModal from "../shared/AllFailureModal";

function Department() {


    const [departmentList, setdepartmentList] = useState([]);
    const [formData, setformData] = useState({
        department_name: "",
    })
    const [add, setadd] = useState(false);
    const [showModal, setShowModal] = useState(false); 
    const [departmentid, setDepartmentid] = useState(null); 
    const [modalMessage, setModalMessage] = useState(""); 
    const [operationType, setOperationType] = useState(""); 
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredDepartments, setFilteredDepartments] = useState([]);
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState(null);
    const [actionType, setActionType] = useState("");
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [showFailureModal, setShowFailureModal] = useState(false);
    const [failureMessage, setFailureMessage] = useState("");
    const headers = {
      "x-access-token": localStorage.getItem("jwttoken") || "",
    };
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [pageSize, setPageSize] = useState(100);
    const getDepartmentList = async () => {
        try {
            setLoader(true);
            const url = process.env.REACT_APP_API_URL + 'department/getdepartment';
            const response = await axios.get(url, { headers });
            setdepartmentList(response.data);
            setFilteredDepartments(response.data);
            setCurrentPage(1);
            setTotalPages(1);  
        } catch (error) {
            setError(error.message || "Failed to fetch departments.");
            setFailureMessage("Failed to fetch departments. Please try again.");
            setShowFailureModal(true);
        }finally {
          setLoader(false);
        }
    };

    useEffect(() => {
        getDepartmentList();
      }, []);
    
    
    useEffect(() => {
        const debounceTimeout = setTimeout(() => {
          if (searchTerm === "") {
            setFilteredDepartments(departmentList);
          } else {
            const filtered = departmentList.filter(department =>
              department.department_name.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredDepartments(filtered);
            setCurrentPage(1);
            setTotalPages(Math.ceil(filtered.length / pageSize));
          }
        }, 300);
        return () => clearTimeout(debounceTimeout);
      }, [searchTerm, departmentList]);
      const handlePageChange = (page) => {
        setCurrentPage(page);
      };
    
      const startEntry = (currentPage - 1) * pageSize + 1;
      const endEntry = Math.min(currentPage * pageSize, filteredDepartments.length);
      const handleSearch = (e) => {
        setSearchTerm(e.target.value);
      };

    const handleAction = async () => {      
      try {
        let url = "";
        if (actionType === "Delete") {
          if (!departmentid) return;
          url = `${process.env.REACT_APP_API_URL}department/delete/${departmentid}`;
          await axios.delete(url, { headers });
          setSuccessMessage("Department deleted successfully.");
        } 
        else if (actionType === "Confirm") {
          console.log("hello")
          url = process.env.REACT_APP_API_URL + 'department/adddepartment';
          await axios.post(url, { ...formData }, { headers });
          setSuccessMessage("Department Added successfully.");
          setformData({ department_name: "" });
          setadd(false);
        } 

        getDepartmentList();
        setShowSuccessModal(true);
        
      } catch (error) {
        setFailureMessage(`Failed to ${actionType} department. ${error.message || ''}`);
        setShowFailureModal(true);
      } finally {
        setShowModal(false);
        setDepartmentid(null);
      }
    };


    const triggerActionModal = (action, departmentId) => {
      if (departmentId) setDepartmentid(departmentId);
      setActionType(action);
      console.log(action)
      if (action === "Delete") {
        setModalMessage("Are you sure you want to delete this department?");
      }
      else if (action === "Confirm") {
        setModalMessage("Are you sure you want to Add this department?");
      }
      setShowModal(true);
    };
    // useEffect(() => {
    //     getDepartmentList();
    // }, []);

    
   
    return (
        <>
            <div className="">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="text-black fw-bold">Department Management</h2>
          <div className="d-flex gap-2 align-items-center" style={{ width: "500px" }}>
            <span className="fw-bold text-secondary text-nowrap">
              {filteredDepartments.length} results
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Search by Department Name"
              value={searchTerm}
              onChange={handleSearch}
            />
            <button
              type="button"
              onClick={() => setadd(true)}
              className="btn bg-info text-white"
            >
              + Add Department
            </button>
          </div>
        </div>

            
                {add && (
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <div className="card shadow-sm border-0 rounded">
                                <div className="card-header text-center text-white" style={{ backgroundColor: "#00bcd4" }}>
                                    <h4 className="mb-0">Department Details</h4>
                                </div>
                                <div className="card-body p-4">
                                    <div className="mb-4">
                                        <label htmlFor="departmentName" className="form-label fw-bold">Department Name</label>
                                        <input type="text"
                                            className="form-control"
                                            id="department_name"
                                            placeholder="Enter department name"
                                            required value={formData.department_name}
                                            onChange={(e) => setformData({ ...formData, department_name: e.target.value })}
                                        />
                                    </div>
                                    <div className='d-flex justify-content-between mt-4'>
                                        <button className="btn text-white" style={{ backgroundColor: "#00bcd4" }} onClick={() => triggerActionModal("Confirm")}>Add Department</button>
                                        <button className="btn btn-secondary" onClick={() => {
                                            setadd(false)
                                        }}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <br></br>
        <div className="card shadow-sm border-0 rounded">
          <div className="card-header bg-info border-bottom py-3">
            <h5 className="mb-0 text-white">Department List</h5>
          </div>
          <div className="card-body p-0">
          <div className="table-responsive" style={{ maxHeight: "500px", overflowY: "auto" }}>
          <table className="table table-hover align-middle mb-0">
                    <thead className='position-sticky top-0 bg-light'>
                        <tr>
                            <th>#</th>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Created On</th>
                            {/* <th>Updated on</th> */}
                            <th className="text-center">Status</th>
                            <th className="text-center">Actions</th>
                            
                        </tr>
                    </thead>
                    <tbody>
                    {loader ? (
                                      <tr>
                                        <td colSpan={9} className="text-center py-2">
                                          <img src={loaderimage} alt="Loading..." height="40" />
                                        </td>
                                      </tr>
                                    ) : error ? (
                                      <tr>
                                        <td colSpan={9} className="text-center text-danger fw-bold py-3">
                                          <div className="alert alert-danger text-center m-3" role="alert">
                                            Oops! Something went wrong. Please try again later.
                                          </div>
                                        </td>
                                      </tr>
                                    ): filteredDepartments.length > 0 ? (
                        filteredDepartments.map((department, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{department.department_id}</td>
                                <td>{department.department_name}</td>
                                <td>{department.createdOn.substring(0, 10)}</td>
                                {/* <td>{department.updatedOn.substring(0, 10)}</td> */}
                                {/* CHANGE: Status column with green/red circle */}
                      <td className="text-center">
                        <span
                          className={`me-2 rounded-circle d-inline-block ${
                            department.isActive === 1 ? "bg-success" : "bg-danger"
                          }`}
                          style={{ width: "20px", height: "20px" }}
                        ></span>
                      </td>

                      {/* CHANGE: Single "Actions" column */}
                      <td className="text-center">
                        <div className="d-flex justify-content-center gap-2">
                          <Link
                            to={`/updatedepartment/${department.department_id}`}
                            className="btn btn-sm btn-outline-warning"
                          >
                            Edit
                          </Link>
                          <button
                            onClick={() => triggerActionModal("Delete", department.department_id)}
                            className="btn btn-sm btn-outline-secondary"
                          >
                            Delete
                          </button>
                          </div>
                                </td>
                            </tr>
                        ))
                      ) : (
                      <tr>
                        <td colSpan={10} className="text-center  text-muted fw-bold">
                          <div className="alert alert-secondary text-center m-3" role="alert">
                            No departments found
                          </div>
                        </td>
                      </tr>
              
                    )}
                    </tbody>
                </table>
            </div>
            <div className="position-sticky bottom-0 bg-white py-2 border-top">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="text-muted ps-3">
                    Showing {startEntry}-{endEntry} of {filteredDepartments.length} entries
                  </div>
                  <nav>
                    <ul className="pagination mb-0 pe-3">
                      <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button 
                          className="page-link" 
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          Previous
                        </button>
                      </li>
                      {[...Array(totalPages)].map((_, index) => (
                        <li 
                          key={index} 
                          className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}
                        >
                          <button 
                            className="page-link" 
                            onClick={() => handlePageChange(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}
                      <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button 
                          className="page-link" 
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
         </div>
         </div>
         </div>

                <ConfirmationModal
                  show={showModal}
                  modalMessage={modalMessage}
                  operationType={actionType}
                  confirmation={handleAction}
                />
                <NewconfirmationModal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} modalMessage={successMessage} operationType="OK" timeoutDuration={3000} />
                <AllFailureModal show={showFailureModal} onHide={() => setShowFailureModal(false)} modalMessage={failureMessage} operationType="OK" timeoutDuration={5000} />
            
        </>
    );
}

export default Department